import { render, staticRenderFns } from "./SitchModifierSelection.vue?vue&type=template&id=25a612fb&scoped=true&"
import script from "./SitchModifierSelection.vue?vue&type=script&lang=ts&"
export * from "./SitchModifierSelection.vue?vue&type=script&lang=ts&"
import style0 from "./SitchModifierSelection.vue?vue&type=style&index=0&id=25a612fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a612fb",
  null
  
)

export default component.exports